<div class="flex flex-col items-center">
  <!-- OTP inputs -->
  <div
    *ngIf="fields?.componentId === 'otpInputField' && otpArray"
    [formGroup]="formGroup"
    class="flex flex-wrap justify-center gap-2.5 mb-5"
  >
    <div formArrayName="otpArray" class="flex flex-wrap justify-center gap-2.5">
      <ng-container *ngFor="let control of otpArray.controls; index as i">
        <input
          #focusInput
          type="text"
          maxlength="1"
          [formControlName]="i"
          oninput="
            event.target.value = event.target.value.replace(/[^0-9]*/g, '')
          "
          class="border border-gray-300 rounded-md w-10 h-10 text-center bg-white dark:bg-coal-700 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          (input)="onOtpInput(i)"
          (keydown)="onOtpKeyDown($event, i)"
          (paste)="onOtpPaste($event)"
        />
      </ng-container>
    </div>
  </div>

  <!-- Absolutely positioned error -->
  <div
    *ngIf="errorMessage"
    class="left-0 w-full text-center text-danger text-sm mt-1"
    [ngStyle]="fields.properties.errorStyle"
  >
    {{ errorMessage }}
  </div>
</div>
<div class="flex justify-center">
  <app-resend-otp [workflowData]="workflowData"></app-resend-otp>
</div>
